import { AfterViewInit, Directive, ElementRef, inject, input } from '@angular/core';

@Directive({
  selector: '[appLink]'
})
export class Link implements AfterViewInit {
  private el = inject(ElementRef);
  private link: HTMLAnchorElement;
  appLink = input('');

  ngAfterViewInit(): void {
    this.link.href = this.appLink();
  }

  constructor() {
    this.link = this.el.nativeElement as HTMLAnchorElement;
    this.link.target = "_self";
  }
}
